import { ConnectionDetailInfo, isSameConnectionDetailInfo } from './ConnectionDetailInfo';
import { FlowBasicInfo } from './FlowInfo';
import { IContentInfo } from './IContentInfo';
import { IDataSourceBasicInfo } from './IDataSourceInfo';

export interface IDataConnectionInfoProperties {
  connectionType: string;
  connectionTypeDisplayName: string;

  connectionDetails: ConnectionDetailInfo; // The specific subtype of this object depends on the connectionDetails.type

  connectionTypeEditable: boolean;
  connectionOAuth: boolean;
}

export interface IDataConnectionInfo extends
  IDataConnectionInfoProperties,
  IContentInfo
{
  datasource?: IDataSourceBasicInfo;
  flow?: FlowBasicInfo;
}

export const isSameDataConnectionInfoProperties = (left: IDataConnectionInfoProperties) => (right: IDataConnectionInfoProperties) =>
  isSameConnectionDetailInfo(left.connectionDetails)(right.connectionDetails);
